<template>
    <div class="col-xs-12 margin-bottom">
      <h4>Accessorials at {{ type }}</h4>
      <div class="table-responsive">
        <table v-if="jobAccessorials && jobAccessorials.length" class="table table-striped table-bordered table-hover">
          <thead>
          <tr>
            <th>Accessorial Charge</th>
            <th>Per</th>
            <th>Rate in Currency</th>
            <th>{{ baseCurrency }} Rate</th>
            <th>Quantity</th>
            <th>Currency Total</th>
            <th>{{ baseCurrency }} Total</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, i) in jobAccessorials" :key="i">
            <td>{{ item.description }}</td>
            <td>{{ item.ratesPerName }}</td>
            <td class="text-right">{{ item.rateText }}</td>
            <td class="text-right">{{ numberFormat(item.baseRate) }}</td>
            <td style="width: 30px; padding: 0">
              <input class="form-control text-right" v-model="item.quantity" />
            </td>
            <td class="text-right">{{ numberFormat(item.subtotal) }}</td>
            <td class="text-right">{{ numberFormat(item.baseSubtotal) }}</td>
            <td class="text-right">
              <a data-toggle="tooltip" title="Delete" class="btn btn-danger" @click="remove(item, i)">
                <em class="fa fa-trash" />
              </a>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="col-xs-12 col-lg-4 col-md-6">
        <div class="form-group" v-if="accessorials">
          <label for="accessorial" class="form-label">Select Accessorial to Add at {{ type }}</label>
          <select class="form-control" v-model="accessorial" id="accessorial" @change="addAccessorial($event)">
            <option value="" />
            <option v-for="(opt, i) in accessorials" :value="opt.optionNumber">
              {{ opt.description }} - {{ numberFormat(opt.rate) }} {{ opt.currency }} {{ opt.ratesPerName }}
            </option>
          </select>
        </div>
      </div>
  </div>
</template>

<script>
  import event from '../../../event'

  export default {
    name: 'QuoteAccessorials',
    props: {
      reportingCurrency: {
        type: String,
        required: true
      },
      jobCurrency: {
        type: String,
        required: false
      },
      quoteCurrency: {
        type: String,
        required: false
      },
      rate: {
        type: Object,
        required: true
      },
      rateRequest: {
        type: Object,
        required: true
      },
      type: {
        type: String,
        required: true
      },
      jobAccessorials: {
        type: Array,
        required: true
      },
      serviceCode: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        accessorial: null,
        accessorials: null,
        baseCurrency: null
      }
    },
    mounted () {
      this.initAccessorials()
    },
    methods: {
      initAccessorials () {
        if (this.serviceCode) {
          const serviceRateItem = this.rate && this.rate.item ? this.rate.item.find(rate => rate.service === this.serviceCode) : null
          const ownerCode = serviceRateItem && serviceRateItem.serviceProvider
          const accessorialRequest = { ...this.rateRequest, Service: this.serviceCode, ownerCode }
          const inverseLocationType = this.type === 'Origin' ? 'Destination' : 'Origin'
          delete accessorialRequest[inverseLocationType + 'Town']
          delete accessorialRequest[inverseLocationType + 'State']
          delete accessorialRequest[inverseLocationType + 'Country']
          this.$store.dispatch('quote/send' + this.type + 'AccessorialRequest', accessorialRequest)
            .then(({responseCurrency, option}) => {
              this.accessorials = option.sort((a, b) => { return a.description < b.description ? -1 : a.description > b.description ? 1 : 0 })
              this.baseCurrency = responseCurrency
              this.recalculateJobAccessorialsWithOldExchangeRates()
            })
            .catch(err => {
              console.log(err)
              event.$emit('toast', {message: JSON.parse(err).responseNotes, type: 'error'})
            })
        }
      },
      addAccessorial ({target}) {
        const selectedAccessorial = this.accessorials.find(({optionNumber}) => optionNumber === parseInt(target.value))
        if (selectedAccessorial) {
          this.$emit('add-accessorial', this.initJobAccessorial(selectedAccessorial))
          this.accessorial = null
        }
      },
      initJobAccessorial (selectedAccessorial) {
        const exchangeRate = selectedAccessorial.exchangeRate
        const baseMinimumCost = exchangeRate ? selectedAccessorial.minimumCost / exchangeRate : selectedAccessorial.minimumCost
        return {
          accessorial: {...selectedAccessorial},
          description: selectedAccessorial.description,
          ratesPerName: selectedAccessorial.ratesPerName,
          rate: selectedAccessorial.rate,
          rateText: `${this.numberFormat(selectedAccessorial.rate)} ${selectedAccessorial.currency}`,
          baseRate: selectedAccessorial.baseRate.toFixed(2),
          baseCurrency: this.baseCurrency,
          quantity: 1,
          get baseSubtotal () {
            const calculated = this.baseRate * this.quantity
            const baseSubTotal = calculated && (baseMinimumCost > calculated) ? baseMinimumCost : calculated
            return baseSubTotal.toFixed(2)
          },
          get subtotal () {
            const calculated = selectedAccessorial.rate * this.quantity
            const subtotal = calculated && (selectedAccessorial.minimumCost > calculated) ? selectedAccessorial.minimumCost : calculated
            return subtotal.toFixed(2)
          }
        }
      },
      recalculateJobAccessorialsWithOldExchangeRates () {
        // jobAccessorial has their own exchange rates stored. If Job's quoteCurrency is not equal to new quoteCurrency, it should recalculate based on exchange rate.
        if (this.jobAccessorials && this.jobAccessorials.length && this.accessorials && this.accessorials.length && this.jobCurrency !== this.quoteCurrency) {
          this.jobAccessorials.forEach(jobAccessorial => {
            if (jobAccessorial.accessorial && jobAccessorial.accessorial.id && jobAccessorial.currency && jobAccessorial.currency.code) {
              const withSameCurrency = this.accessorials.find(item => item.currency === jobAccessorial.currency.code)
              if (withSameCurrency) {
                jobAccessorial.exchangeRate = withSameCurrency.exchangeRate
                jobAccessorial.baseAmount = jobAccessorial.rate / jobAccessorial.exchangeRate
                jobAccessorial.baseRate = jobAccessorial.baseAmount.toFixed(2)
              }
            }
          })
        }
      },
      remove (item, i) {
        this.jobAccessorials.splice(i, 1)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// QuoteAccessorialItem.vue?245fea98